import React, { useEffect } from 'react';
import {useStyles} from "./styles/MyPageStyle";
import {
    Box,
    Button,
    Typography,
    TextField,
} from "@material-ui/core";
import clsx from "clsx";
import {USER_TYPE} from "../../../stores/UserStore";
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";


function MyPage(props) {
    const classes = useStyles();
    const {intl} = props;
    const {userStore, authStore} = props;
    const userType = authStore.getUserType();
    const user = userStore.userProfile;

    useEffect(() => {
        userStore.getUserProfile(authStore.loginUser.id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangePassword = (e) => {
        let userProfile = Object.assign({}, userStore.userProfile);
        userProfile.password = String(e.target.value).trim();
        userStore.setUserProfile(userProfile);
    }

    const handleChangeNewPassword = (e) => {
        let userProfile = Object.assign({}, userStore.userProfile);
        userProfile.newPassword = String(e.target.value).trim();
        userStore.setUserProfile(userProfile);
    }

    const handleChangeConfirmPassword = (e) => {
        let userProfile = Object.assign({}, userStore.userProfile);
        userProfile.confirmPassword = String(e.target.value).trim();
        userStore.setUserProfile(userProfile);
    }

    const handleChangeEmail = (e) => {
        let userProfile = Object.assign({}, userStore.userProfile);
        userProfile.email = String(e.target.value).trim();
        userStore.setUserProfile(userProfile);
    }

    const handleChangeName = (e) => {
        let userProfile = Object.assign({}, userStore.userProfile);
        userProfile.name = String(e.target.value).trim();
        userStore.setUserProfile(userProfile);
    }

    const canModify = () => {
        if (userStore.userProfile.password === '') {
            return false;
        }
        if (userStore.userProfile.newPassword !== userStore.userProfile.confirmPassword) {
            return false;
        }
        if (userType === USER_TYPE.Normal) {
            if (userStore.userProfile.name === '') {
                return false;
            }
        }
        return true;
    }

    const handleClickModify = () => {
        userStore.updateUserProfile(intl, authStore.loginUser.id);
    }

    return (
        <Box className={classes.root}>
            {user.id &&
                <Box className={classes.myPageBox}>
                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                        <Typography className={classes.myPageTitle}>ID</Typography>
                        <Typography className={classes.myPageText}>{user.id}</Typography>
                    </Box>
                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "authority"})}</Typography>
                        <Typography className={classes.myPageText}>{intl.formatMessage({id: user.type})}</Typography>
                    </Box>
                    {userType !== USER_TYPE.Admin &&
                        <>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "Locale"})}</Typography>
                                <Typography className={classes.myPageText}>{intl.formatMessage({id: user.localeCode})}</Typography>
                            </Box>
                            {userType !== USER_TYPE.LocaleAdmin &&
                                <>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "group_type"})}</Typography>
                                        <Typography className={classes.myPageText}>{intl.formatMessage({id: user.localeGroupType})}</Typography>
                                    </Box>
                                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "belong_group_name"})}</Typography>
                                        <Typography className={classes.myPageText}>{user.localeGroupName}</Typography>
                                    </Box>
                                </>
                            }
                        </>

                    }

                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "current_password"})}<span>*</span></Typography>
                            <Box className={classes.emailBox}>
                                <form><TextField variant="outlined" placeholder={intl.formatMessage({id: "password"})} type="password" autoComplete="off" value={user.password} onChange={handleChangePassword}/></form>
                            </Box>
                    </Box>
                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                        <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "new_password"})}</Typography>
                        <Box className={classes.emailBox}>
                            <form><TextField variant="outlined" placeholder={intl.formatMessage({id: "new_password"})} type="password" autoComplete="off" value={user.newPassword} onChange={handleChangeNewPassword}/></form>
                        </Box>
                    </Box>
                    {user.newPassword !== '' &&
                        <Box className={classes.emailContent}>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.myPageTitle}>{intl.formatMessage({id: "verify_new_password"})}<span>*</span></Typography>
                                <Box className={classes.emailBox} >
                                    <form><TextField variant="outlined" placeholder={intl.formatMessage({id: "verify_password"})} type="password" autoComplete="off" value={user.confirmPassword} onChange={handleChangeConfirmPassword}/></form>
                                </Box>
                            </Box>
                            {(user.confirmPassword !== '' && (user.newPassword !== user.confirmPassword)) &&
                                <Typography className={classes.emailNotice}>{intl.formatMessage({id: "msg_info_not_match_password"})}</Typography>
                            }
                        </Box>
                    }

                    {userType !== USER_TYPE.Normal ?
                        <Box className={classes.emailContent}>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.emailTitle}>{intl.formatMessage({id: "email"})}</Typography>
                                <Box className={classes.emailBox} >
                                    <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "email"})} value={user.email !== null ? user.email : ''} onChange={handleChangeEmail}/>
                                </Box>
                            </Box>
                            <Typography className={classes.emailNotice}>{intl.formatMessage({id: "msg_info_profile_email"})}</Typography>
                        </Box>
                        :
                        <Box className={classes.emailContent}>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.emailTitle}>{intl.formatMessage({id: "name"})}<span>*</span></Typography>
                                <Box className={classes.emailBox} >
                                    <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "name"})} value={user.name !== null ? user.name : ''} onChange={handleChangeName}/>
                                </Box>
                            </Box>
                        </Box>
                    }
                    <Box display={"flex"} justifyContent={"center"} alignItems={"center"}>
                        <Button className={canModify() ? clsx(classes.inputButton, classes.inputButtonActive) : classes.inputButton} disableRipple disabled={!canModify()} onClick={handleClickModify}>
                            <Typography>{intl.formatMessage({id: "modify"})}</Typography>
                        </Button>
                    </Box>
                </Box>
            }
        </Box>
    );
}

export default inject('userStore', 'authStore')(injectIntl(observer(MyPage)));
